import { useCallback, useMemo } from 'react'
import { useLocation } from 'react-router'

import { notifyGuideTourInteraction } from '../notifications/interaction'
import { useGuideTour } from '../provider/guideTourContext'
import { isGuideTourActivationStepTargetMissing } from '../routing/activation'
import { getGuideTourStepRoute } from '../routing/utils'
import {
  countAvailableGuideTourSteps,
  findNextAvailableGuideTourStepIndex,
  getAvailableGuideTourStepNumber,
  resolveGuideTourForRuntime,
} from '../utils/tourRuntime'
import { selectGuideTourForButton } from './selectGuideTourForButton'

export const useGuideTourButton = () => {
  const { pathname: routePathname } = useLocation()
  const { registry, launchGuideTour, currentPathname } = useGuideTour()

  const pathname = routePathname || currentPathname

  const tour = useMemo(
    () => selectGuideTourForButton(pathname, registry),
    [pathname, registry]
  )

  const handleClick = useCallback(() => {
    if (!tour) {
      return
    }

    const activeTour = resolveGuideTourForRuntime(tour)
    const stepIndex = findNextAvailableGuideTourStepIndex(activeTour, 0) ?? 0
    const step = activeTour.steps[stepIndex]
    const activationTargetMissing = isGuideTourActivationStepTargetMissing(
      activeTour,
      stepIndex
    )

    if (!activationTargetMissing) {
      notifyGuideTourInteraction({
        action: 'restart',
        componentName: 'restart',
        pathname,
        route:
          (step && getGuideTourStepRoute(activeTour, step)) ||
          activeTour.route ||
          pathname,
        tour: activeTour,
        step,
        currentStep: getAvailableGuideTourStepNumber(activeTour, stepIndex),
        totalStep: countAvailableGuideTourSteps(activeTour),
      })
    }

    launchGuideTour(tour.id, 'restart')
  }, [launchGuideTour, pathname, tour])

  return {
    isVisible: tour !== undefined,
    onClick: handleClick,
  }
}
